import React, {Component} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import {Alert} from 'reactstrap';
import { FaUserAlt, FaEye, FaEyeSlash } from "react-icons/fa";
import { Link } from 'react-router-dom';
import Breadcrumb from '../../Layout/Breadcrumb';
import { Spinner } from 'react-bootstrap';

class EditUserComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userId: 0,
            isLoading: true,
            btnSubmit: false,
            listGroupUser: null,
            error: false,
            messageError: '',
            loadPage: true,
            name: '',
            email: '',
            gender: 'nam',
            role: 'user',
            phone: '',
            address: '',
            group_user_id: '0',
            password_confirmation: '',
            password: '',
            typePassword: 'password',
            changePassword: false,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.loadUser(this.props.userId);
        let password = this.generatePassword();
        this.setState({
            password_confirmation: password,
            password: password,
        })
    }

    loadUser = (userId) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/user/editUser/' + userId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listGroupUser: ref.data.content.listGroupUser,
                        loadPage: false,
                        userId: ref.data.content.user.id,
                        name: ref.data.content.user.name,
                        email: ref.data.content.user.email,
                        role: ref.data.content.user.role,
                        group_user_id: ref.data.content.user.group_user_id,
                        gender: ref.data.content.user.user_detail.gender,
                        phone: ref.data.content.user.user_detail.phone,
                        address: ref.data.content.user.user_detail.address,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                        });
                        this.redirect(true, ref.data.message);
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu nhóm khách hàng thất bại',
                    loadPage: false,
                    name: '',
                })
            })
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    showPassword = () => {
        if ( this.state.typePassword === 'password' ) {
            this.setState({
                typePassword: 'text'
            })
        } else {
            this.setState({
                typePassword: 'password'
            })
        }
    }

    generatePassword = () => {
        var length = 12;
        let charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let retVal = "";
        for (var i = 0, n = charset.length; i < length; ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        return retVal;
    }

    submit = (event) => {
        event.preventDefault();
        this.setState({
            btnSubmit: true
        })
        if ( this.validate() ) {
            this.setState({
                loadPage: true
            });
            let form = {
                userId: this.state.userId,
                name: this.state.name,
                email: this.state.email,
                phone: this.state.phone,
                address: this.state.address,
                password: this.state.password,
                role: this.state.role,
                gender: this.state.gender,
                group_user_id: this.state.group_user_id,
                changePassword: this.state.changePassword,
            };
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            axios.put( process.env.REACT_APP_API_URL + '/api/admin/user/updateUser', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    this.setState({
                        loadPage: false,
                        btnSubmit: false
                    });
                    if ( ref.data.error === 0 ) {
                        this.setState({
                            listGroupUser: ref.data.content,
                        })
                        this.redirect(true, 'Chỉnh sửa khách hàng thành công');
                    } else {
                        if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                            this.props.logOut();
                        } else {
                            this.setState({
                                error: true,
                                messageError: ref.data.message,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        error: true,
                        messageError: 'Lấy dữ liệu nhóm khách hàng thất bại',
                        loadPage: false,
                        name: '',
                        btnSubmit: false
                    })
                })
        }
    }

    redirect = (is, text) => {
        this.props.notification({
            isNotification: is,
            textNotification: text
        });
        this.props.shouldRedirect();
    }

    validate = () => {
        // return true;
        if ( !this.state.name.length ) {
            this.setState({
                error: true,
                messageError: 'Họ và tên không được để trống',
            })
            return false;
        }
        else if ( this.state.name.length < 5 || this.state.name.length > 200 ) {
            this.setState({
                error: true,
                messageError: 'Số ký tự của Họ và tên không được nhỏ hơn 5 ký tự hoặc lớn hơn 200 ký tự',
            })
            return false;
        }
        else if ( !this.state.email.length ) {
            this.setState({
                error: true,
                messageError: 'Email không được để trống',
            })
            return false;
        }
        else if ( this.state.email.length < 5 || this.state.email.length > 200 ) {
            this.setState({
                error: true,
                messageError: 'Số ký tự của Email không được nhỏ hơn 5 ký tự hoặc lớn hơn 200 ký tự',
            })
            return false;
        }
        else if ( this.state.phone.length < 5 || this.state.phone.length > 200 ) {
            this.setState({
                error: true,
                messageError: 'Số ký tự của Số điện thoại không được nhỏ hơn 5 ký tự hoặc lớn hơn 200 ký tự',
            })
            return false;
        }
        else if ( this.state.address.length < 5 || this.state.address.length > 200 ) {
            this.setState({
                error: true,
                messageError: 'Số ký tự của Địa chỉ không được nhỏ hơn 5 ký tự hoặc lớn hơn 200 ký tự',
            })
            return false;
        }
        if ( this.state.changePassword ) {
            if ( this.state.password.length < 5 || this.state.password.length > 200 ) {
                this.setState({
                    error: true,
                    messageError: 'Số ký tự của Mật khẩu không được nhỏ hơn 5 ký tự hoặc lớn hơn 200 ký tự',
                })
                return false;
            }
            else if ( this.state.password !== this.state.password_confirmation ) {
                this.setState({
                    error: true,
                    messageError: 'Nhập lại mất khẩu không trùng khớp',
                })
                return false;
            }
        }
        return true;
    }

    changePassword = (event) => {
        let value = event.target.checked;
        this.setState({
            changePassword: value
        })
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Chỉnh sửa khách hàng"} page={"Khách hàng"} icon={<FaUserAlt className="breadcrumb-icon" />} />
                            <div className="col-md-6 marginAuto">
                                <div className="card card-info">
                                    <div className="card-header">
                                        <h3 className="card-title text-center">Nhập thông tin khách hàng</h3>
                                    </div>
                                    {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
                                    <form role="form" method="post" action="" autoComplete={"off"} onSubmit={ this.submit }>
                                        <div className="card-body">
                                            <div className="form-group">
                                                {
                                                    this.state.error ? (
                                                        <Alert color="danger">
                                                            <div className='text-center'>
                                                                { this.state.messageError }
                                                            </div>
                                                        </Alert>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="name">Họ và Tên</label>
                                                <input type="text" name="name" className="form-control" id="name" placeholder="Tên" onChange={this.changeInput}  defaultValue={this.state.name}  />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="gender">Giới tính</label>
                                                <select className="form-control" name="gender" onChange={this.changeInput} defaultValue={this.state.gender}>
                                                    <option value="nam">Nam</option>
                                                    <option value="nữ">Nữ</option>
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="email">Email</label>
                                                <input type="email" name="email" className="form-control" onChange={this.changeInput} id="email" placeholder="Email" defaultValue={this.state.email}  />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="phone">Số điện thoại</label>
                                                <input type="text" name="phone" className="form-control" onChange={this.changeInput} id="phone" placeholder="Phone" defaultValue={this.state.phone}  />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="address">Địa chỉ</label>
                                                <input type="text" name="address" className="form-control" onChange={this.changeInput} id="address" placeholder="Địa chỉ" defaultValue={this.state.address}   />
                                            </div>
                                            <div className="form-group">
                                                <label>User role</label>
                                                <select className="form-control" name="role" onChange={this.changeInput} defaultValue={this.state.role}>
                                                    <option value="admin">Admin</option>
                                                    <option value="user">User</option>
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>Nhóm đại lý</label>
                                                <select className="form-control" name="group_user_id" onChange={this.changeInput} defaultValue={this.state.group_user_id}>
                                                    <option value="0">Cơ bản</option>
                                                    {
                                                        this.state.listGroupUser ? (
                                                            this.state.listGroupUser.map( (groupUser, key) => {
                                                                return (
                                                                    <option value={groupUser.id} key={groupUser.id + key}>{ groupUser.name }</option>
                                                                )
                                                            })
                                                        ) : (
                                                            <></>
                                                        )
                                                    }
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <div className="form-check">
                                                    <label className="form-check-label">
                                                        <input id="checkbox2" type="checkbox" onChange={this.changePassword} className="form-check-input" /> Đổi mật khẩu
                                                    </label>
                                                </div>
                                            </div>
                                            {
                                                this.state.changePassword ? (
                                                    <>
                                                        <div className="form-group">
                                                            <label htmlFor="password">Mật khẩu</label>
                                                            <div className=" input-group">
                                                                <input type={ this.state.typePassword } name="password" onChange={this.changeInput} className="form-control" id="password" placeholder="Password" defaultValue={this.state.password}  />
                                                                <div className="input-group-append show_password">
                                                                    <span className="input-group-text" onClick={ () => this.showPassword() }>
                                                                        {
                                                                            this.state.typePassword === 'password' ? (
                                                                                <FaEye />
                                                                            ) : (
                                                                                <FaEyeSlash />
                                                                            )
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="password_confirmation">Nhập lại mật khẩu</label>
                                                            <input type="password" name="password_confirmation" id="password_confirmation" onChange={this.changeInput} className="form-control" placeholder="Nhập lại mật khẩu" defaultValue={this.state.password_confirmation}  />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                        </div>
                                        <div className="card-footer">
                                            <Link to="/admin/khach-hang" className="btn btn-default">Hủy</Link>
                                            <button type="submit" className="btn btn-info float-right" disabled={ this.state.btnSubmit }>Xác nhận</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </>
                    )
                }
            </>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({type : 'logOut'}))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EditUserComponent);